/* unplugin-vue-components disabled */import { render } from "./CustomFields.vue?vue&type=template&id=8f9dffc0&ts=true"
import script from "./CustomFields.vue?vue&type=script&lang=ts"
export * from "./CustomFields.vue?vue&type=script&lang=ts"

import "./CustomFields.vue?vue&type=style&index=0&id=8f9dffc0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__